import React from 'react';
import { Button, SvgIcon } from '@gik/ui';
import noop from '@gik/core/utils/noop';
import bemBlock from '@gik/core/utils/bemBlock';
import { FormRenderProps } from 'react-final-form';

export interface ICalendarClaimFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  form?: FormRenderProps;
  backButton?: boolean;
  cancelButton?: boolean;
  unclaimButton?: boolean;
  closeButton?: boolean;
  editEventButton?: boolean;
  saving?: boolean;
  onBack?: () => void | Promise<void>;
  onCancel?: () => void | Promise<void>;
  onClose?: () => void | Promise<void>;
  onEditEvent?: () => void | Promise<void>;
  onUnclaim?: () => void | Promise<void>;
}

export function CalendarClaimFooter({
  form,
  backButton,
  cancelButton,
  unclaimButton,
  closeButton,
  editEventButton,
  children,
  saving,
  onBack = noop,
  onCancel = noop,
  onClose = noop,
  onEditEvent = noop,
  onUnclaim = noop,
  className,
}: ICalendarClaimFooterProps): React.ReactElement {
  const bem = bemBlock('calendar-claim-footer');

  const isLoading = form?.submitting || saving;

  return (
    <div className={bem(null, null, className)}>
      <section>
        {backButton && (
          <Button variant={'default-light'} onClick={onBack} circle disabled={isLoading} loading={isLoading}>
            <SvgIcon name="ChevronLeft" />
          </Button>
        )}

        {unclaimButton && (
          <Button
            variant={'danger'}
            onClick={onUnclaim}
            disabled={isLoading}
            loading={isLoading}
            prepend={<SvgIcon name="Trash" />}
          >
            Unclaim
          </Button>
        )}
      </section>
      <section>
        {cancelButton && (
          <Button variant={'default'} onClick={onCancel} disabled={isLoading} loading={isLoading}>
            Cancel
          </Button>
        )}
        {editEventButton && (
          <Button
            variant={'secondary'}
            onClick={onEditEvent}
            disabled={isLoading}
            loading={isLoading}
            prepend={<SvgIcon name="Pencil" />}
          >
            Edit Request
          </Button>
        )}
        {closeButton && (
          <Button variant={'default'} onClick={onClose} disabled={isLoading} loading={isLoading}>
            Close
          </Button>
        )}
        {children}
      </section>
    </div>
  );
}
